import Vue from "vue";
export default {
  install(_Vue: any) {
    // this vue instance will make the
    // '$alert' object reactive to
    // the vue instances using it
    const VM = new Vue({
      data: {
        $$state: {},
        list: []
      }
    });

    _Vue.prototype.$alert = function(message: string): Promise<null> {
      return new Promise<null>(resolve => {
        let newAlert = {
          id:
            "_" +
            Math.random()
              .toString(36)
              .substr(2, 9), // random id
          message,
          createdAt: Date.now(),
          resolve: () => {}
        };

        VM.$$state = {
          ...VM.$$state,
          [newAlert.id]: newAlert
        };
        VM.list = Object.values(VM.$$state).sort(
          (a: any, b: any) => a.createdAt - b.createdAt
        ) as any;

        if (resolve) newAlert.resolve = resolve;
      });
    };
    _Vue.prototype.$dismissAlert = function(alertID: string) {
      let state: any = { ...VM.$$state };
      const alert = state[alertID];

      if (alert) {
        delete state[alertID];
        VM.$$state = { ...state };
        VM.list = Object.values(VM.$$state).sort(
          (a: any, b: any) => a.createdAt - b.createdAt
        ) as any;

        alert.resolve();
      }
    };

    _Vue.prototype.$alert._vm = VM;
  }
};
